export default __webpack_public_path__ + "static/media/contact-care-img.15a099d7.svg";